const partWrapper = "_partWrapper_1ku35_1";
const userWrapper = "_userWrapper_1ku35_7";
const userPart = "_userPart_1ku35_11";
const assistantWrapper = "_assistantWrapper_1ku35_19";
const assistantPart = "_assistantPart_1ku35_19";
const markdown = "_markdown_1ku35_19";
const toolInvocationPart = "_toolInvocationPart_1ku35_80";
const toolInvocationText = "_toolInvocationText_1ku35_91";
const debug = "_debug_1ku35_95";
const toolInvocationDebug = "_toolInvocationDebug_1ku35_105";
const styles = {
	partWrapper: partWrapper,
	userWrapper: userWrapper,
	userPart: userPart,
	assistantWrapper: assistantWrapper,
	assistantPart: assistantPart,
	markdown: markdown,
	toolInvocationPart: toolInvocationPart,
	toolInvocationText: toolInvocationText,
	debug: debug,
	toolInvocationDebug: toolInvocationDebug
};

export { styles as s };
//# sourceMappingURL=CopilotMessagePart.module-DU9_L9rT.mjs.map
